export const runConfig = {
  "request_domain": {
    "dev": "https://gw-me-kaifa.myxrk.cn",
    "test": "https://gw-me-test.myxrk.cn",
    "pre": "https://gw-me-ysc.myxrk.cn",
    "prod": "https://gw-me.myxrk.com"
  },
  "run_request_domain": "https://gw-me.myxrk.com"
}